import { Controller } from "@hotwired/stimulus"

// Toggles the embeddings connection fields based on the selected embeddings
// provider. Azure OpenAI needs an endpoint and API version; OpenAI does not.
// Switching provider invalidates the stored key, so the secret field is opened
// and a new key must be entered before the form can be saved.
export default class extends Controller {
  static targets = ["azureOnly", "endpointInput"]

  connect() {
    this.savedProvider = this.currentProvider()
    this.toggleFields()
  }

  currentProvider() {
    const select = this.element.querySelector('select[name*="[ai_embeddings_provider]"]')
    return (select ? select.value : "openai").toLowerCase()
  }

  toggleFields() {
    const provider = this.currentProvider()
    const isAzure = provider === "azure_openai"

    // Empty string falls back to the stylesheet default, so this works for
    // both block-level form groups and inline hint spans.
    // Show/hide only — do not toggle HTML5 `required` on the endpoint. The form
    // is novalidate; `required-fields` enforces whatever is left on screen.
    this.azureOnlyTargets.forEach(el => { el.style.display = isAzure ? "" : "none" })

    this.syncSecretField(provider)
  }

  syncSecretField(provider) {
    const el = this.element.querySelector('[data-controller~="secret-field"]')
    const secretField = el ? this.application.getControllerForElementAndIdentifier(el, "secret-field") : null
    if (!secretField) return

    if (provider === this.savedProvider) {
      secretField.reset()
    } else {
      secretField.edit()
    }
  }
}
